import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAeratorWithSparger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 35,
	height: 97.4,
	viewBox: "0 0 35.0 97.4",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 23.5 2.4 L 23.5 27.4 A 5.0 2.0 0.0 0 1 11.5 27.4 L 11.5 2.4 A 5.0 2.0 0.0 0 1 23.5 2.4 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 92.4,
			width: 30,
			height: 5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.5,
			y: 29.9,
			width: 2,
			height: 57.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 11.5 2.4 L 23.5 2.4 M 11.5 27.4 L 23.5 27.4",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22.5,
			cy: 87.4,
			rx: 5,
			ry: 1,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12.5,
			cy: 87.4,
			rx: 5,
			ry: 1,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.5,
			cy: 94.9,
			rx: 2.5,
			ry: 2.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.5,
			cy: 94.9,
			rx: 2.5,
			ry: 2.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgAeratorWithSparger;
